var chunkMapping = {
	"647": [
		40647
	],
	"824": [
		40824
	],
	"826": [
		60826
	],
	"1207": [
		51207
	],
	"1237": [
		1237
	],
	"1293": [
		81293
	],
	"1350": [
		11350
	],
	"1545": [
		1545
	],
	"1856": [
		81856
	],
	"2222": [
		72222
	],
	"4153": [
		76534
	],
	"4211": [
		4211
	],
	"5665": [
		45665
	],
	"7138": [
		7138
	],
	"7464": [
		77464
	],
	"7857": [
		97857
	],
	"8767": [
		8767
	],
	"9178": [
		79178
	],
	"9317": [
		79317
	],
	"9934": [
		19934
	]
};
var idToExternalAndNameMapping = {
	"1237": [
		"default",
		"./analytics-snap-business/tw.json",
		68767
	],
	"1545": [
		"default",
		"./analytics-snap-business/cn.json",
		68767
	],
	"4211": [
		"default",
		"./analytics-snap-business/en.json",
		68767
	],
	"7138": [
		"default",
		"./analytics-patent-view/cn.json",
		68767
	],
	"8767": [
		"default",
		"./common-country/en.json",
		68767
	],
	"11350": [
		"default",
		"./analytics-patent-view/tw.json",
		68767
	],
	"19934": [
		"default",
		"./analytics-snap-business/jp.json",
		68767
	],
	"40647": [
		"default",
		"./common-patent/cn.json",
		68767
	],
	"40824": [
		"default",
		"./common-errorcode/en.json",
		68767
	],
	"45665": [
		"default",
		"./common-errorcode/jp.json",
		68767
	],
	"51207": [
		"default",
		"./common-patent/tw.json",
		68767
	],
	"60826": [
		"default",
		"./common-errorcode/cn.json",
		68767
	],
	"72222": [
		"default",
		"./common-errorcode/tw.json",
		68767
	],
	"76534": [
		"default",
		"./analytics-patent-view/jp.json",
		68767
	],
	"77464": [
		"default",
		"./common-patent/jp.json",
		68767
	],
	"79178": [
		"default",
		"./common-country/jp.json",
		68767
	],
	"79317": [
		"default",
		"./common-patent/en.json",
		68767
	],
	"81293": [
		"default",
		"./common-country/cn.json",
		68767
	],
	"81856": [
		"default",
		"./analytics-patent-view/en.json",
		68767
	],
	"97857": [
		"default",
		"./common-country/tw.json",
		68767
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}